import { FC } from 'react'

import styled from 'styled-components'

import { ContractItem } from 'src/Pages/ContractsPage/ContractItem.tsx'
import { Contract, ContractStatus } from 'src/Redux/api/contractsApi'
import { TableLoading } from 'src/Components/TableLoading'
import { NoDataMessage } from 'src/Components/NoDataMessage'
import { Pagination } from 'src/Helpers/types.ts'
import { User } from 'src/Redux/api/usersApi'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  flex: 1;
  min-height: 0;
`

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-bottom: 16px;
`
type ContractsTableProps = {
  contracts?: Contract[]
  isLoading: boolean
  users: User[]
  currentUserId?: number
  canArchive?: boolean
  onArchive?: (id: number) => void
} & Pagination

export const ContractsTable: FC<ContractsTableProps> = ({
  contracts,
  isLoading,
  users,
  currentUserId,
  canArchive,
  onArchive,
}) => {
  if (isLoading) {
    return (
      <ListWrapper>
        <TableLoading />
      </ListWrapper>
    )
  }

  if (contracts?.length === 0) {
    return (
      <ListWrapper>
        <NoDataMessage />
      </ListWrapper>
    )
  }

  return (
    <Container>
      <ListWrapper>
        {contracts?.map((contract) => (
          <ContractItem
            key={contract.id}
            contract={contract}
            status={ContractStatus.Draft}
            users={users}
            currentUserId={currentUserId}
            canArchive={canArchive}
            onArchive={onArchive}
          />
        ))}
      </ListWrapper>
    </Container>
  )
}
